import { IconProps } from "models"

const Wave: React.FC<IconProps> = ({
	className = "",
	style = null,
	width = "1292",
	height = "1080",
}) => {
	return (
		<svg
			className={className}
			style={style}
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 1292 1080"
			aria-hidden="true"
		>
			<defs>
				<path fill="#fff" stroke="#707070" d="M0 0h1292v1080H0z" />
			</defs>
			<path
				d="M144.053-12.457S686.3-8.73 789.258 267.984 949.708 680.34 1157 829.4s114.987 418-338.573 344.216-826.945-32.689-826.945-32.689L-22.678-72.08z"
				fill="rgba(27,20,100,0.03)"
			/>
			<path
				d="M148.011-47.457s568.772 6.573 626.213 349.511 248.4 433.011 411.246 591.97 117.256 318.376-347.07 244.589-846.58-32.686-846.58-32.686L-22.678-107.08z"
				fill="rgba(27,20,100,0.09)"
			/>
			<path
				d="M512.692-24.707s50.86 279.606-119 357.083S153.4 469.886 114.66 578.567-3.276 795.847-45.864 802.972s0-833.739 0-833.739z"
				fill="var(--primaryColor)"
				opacity=".2"
			/>
		</svg>
	)
}

export default Wave
